import update from 'immutability-helper';
//import utils from 'web3-utils';

export default function reducer(state={
    showAuthStatus: false,
    authentication: {
        ethAccount: "",
        network: "",
        loggedIn: false,
        hasMetamask: false,
        hasDatabaseAuth: false,
        uuid: "",
        recordedEthAddress: "",
        username: "",
        num: 0,
        trace: "",
        showAuthFlow: false,
        twoWayExists: false,
        tweetId: ""
    },    
    web3: {
        web3Instance: null,
        betManagerContract: null,
        betManagerInstance: null,
        ethAccount: "",
        network: ""
    },
    ethPrice: {}, 
    showOverlay: false,
    pageLoaded: false,
    showProfileMenu : false,
    screenDimensions : { 
        width: document.body.clientWidth, 
        height: document.body.clientHeight 
    },
    sha3ToBedId: {},
    selectedPage : "SUMMARY",
    monitorBetIds: [],
    monitorTxHashes: [],

    blockchainDataMap: {},
    hashDataMap: {},
    proposalDataMap: {},

    pageContext: {},
    textInputData : {}
}, action) {

    switch (action.type) {
        case "NAVIGATE": {
            let { page, context, input, clear } = action.payload;

            if(context === null) { context = {} };
            if(input === null) { input = {} };

            let newPageContext = {};
            let newTextInputData = {};

            if(clear) {
                newPageContext = update(state.pageContext, {
                    [page+"_CONTEXT"]: subContext =>
                    update({}, {$merge:context})
                });
        
                newTextInputData = update(state.textInputData, {
                    [page]: subContext =>
                    update({}, {$merge:input})
                });
            }
            else {
                newPageContext = update(state.pageContext, {
                    [page+"_CONTEXT"]: subContext =>
                    update(subContext || {}, {$merge:context})
                });
        
                newTextInputData = update(state.textInputData, {
                    [page]: subContext =>
                    update(subContext || {}, {$merge:input})
                });
            }

            console.log("NAVIGATE: " + page);
            console.log(newPageContext);

            const newAuthentication = update(state.authentication || {}, {$merge:{showAuthFlow:false}});

            return {...state, selectedPage: page, pageContext: newPageContext, textInputData: newTextInputData, authentication: newAuthentication }
        }
        case "SHOW_PROFILE_MENU": {
            let status = action.payload;
            return {...state, showProfileMenu: status}
        }
        case "UPDATE_BLOCKCHAIN_DATA": {
            let { betId, data } = action.payload;

            if(JSON.stringify(data) === JSON.stringify(state.blockchainDataMap[betId] || {})) {
                return {...state};
            }

            const newBlockchainDataMap = update(state.blockchainDataMap || {}, {$merge:{[betId]:data}});
            return {...state, blockchainDataMap: newBlockchainDataMap }
        }
        case "UPDATE_HASH_DATA": {
            let mapObj = action.payload;
            const newHashDataMap = update(state.hashDataMap || {}, {$merge:mapObj});
            
            console.log("UPDATE_HASH_DATA");
            console.log(newHashDataMap);
            return {...state, hashDataMap: newHashDataMap }
        }
        case "UPDATE_PROPOSAL_DATA": {
            let mapObj = action.payload;
            const newProposalDataMap = update(state.proposalDataMap || {}, {$merge:mapObj});
            
            console.log("UPDATE_PROPOSAL_DATA");
            console.log(newProposalDataMap);
            return {...state, proposalDataMap: newProposalDataMap }
        }
        case "UPDATE_SHA3_TO_BET_ID": {
            let { betId, sha3 } = action.payload;
            const newSha3ToBedId = update(state.sha3ToBedId || {}, {$merge:{[sha3]:betId}});
            return {...state, sha3ToBedId: newSha3ToBedId}
        }        
        case "SHOW_OVERLAY": {
            return {...state, showOverlay: action.payload}
        }
        case "SHOW_AUTH_STATUS": {
            return {...state, showAuthStatus: action.payload}
        }
        case "MONITOR_BET_IDS": {
            return {...state, monitorBetIds: action.payload}
        }
        case "MONITOR_TX_HASHES": {
            return {...state, monitorTxHashes: action.payload}
        }
        case "UPDATE_AUTHENTICATION": {
            console.log("UPDATE_AUTHENTICATION");
            console.log(action.payload);

            return {...state, authentication: action.payload, pageLoaded: true }
        }
        case "UPDATE_SCREEN_DIMENSIONS": {
            let { width, height } = action.payload;
            return {...state, screenDimensions: { width, height }}
        }
        case "UPDATE_ETH_PRICE": {
            console.log(action.payload);
            return {...state, ethPrice: action.payload}
        }
        case "CHANGE_TEXT_INPUT": {
            let { input, page } = action.payload;
            //let newTextInputData = update(state.textInputData, {$merge:{[page]:{[name]:value}}});

            const newTextInputData = update(state.textInputData, {
                [page]: subContext =>
                update(subContext || {}, {$merge:input})
            });

            return {...state, textInputData: newTextInputData}
        }
        case "CHANGE_PAGE_CONTEXT": {
            let { context, page } = action.payload;

            if(context === null) { context = {} };

            let newPageContext = update(state.pageContext, {
                [page+"_CONTEXT"]: subContext =>
                update(subContext || {}, {$merge:context})
            });

            //newPageContext = JSON.parse(JSON.stringify(newPageContext));

            console.log("CHANGE_PAGE_CONTEXT");
            console.log(newPageContext);

            return {...state, pageContext: newPageContext}
        }
        case "UPDATE_WEB3": {
            console.log("UPDATE_WEB3");
            console.log(action.payload);
            return {...state, web3: action.payload };
        }
        default: {
            return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/betReducer.js